import { TextEditor } from "handsontable/editors/textEditor";

export class MonetizeEditor extends TextEditor {
  prepare(row, col, prop, td, originalValue, cellProperties) {
    const displayValue = originalValue ? originalValue / 100 : "";
    super.prepare(row, col, prop, td, displayValue, cellProperties);
  }

  getValue() {
    const value = super.getValue();
    // Multiply by 100 to convert from dollars to cents
    return value ? Math.round(parseFloat(value) * 100) : null;
  }

  beginEditing(initialValue, event) {
    // Use originalValue if initialValue is null
    const valueToEdit =
      initialValue !== null ? initialValue : this.originalValue;
    const displayValue = valueToEdit ? valueToEdit / 100 : "";
    super.beginEditing(displayValue, event);
  }
}
